import React from "react";
import { size, COLORS } from "../../utils";
import { Grid, Typography } from "@mui/material"
import course from '../../assets/lottiefiles/course.json'
import Lottie from 'react-lottie';
import styles from "./Intro.module.css"

export default function Intro() {
    return (
        <Grid item container flexWrap={'nowrap'} direction={'column'} alignItems={'center'}
            justifyContent={'center'} width={size({ p: 70 })} height={size({ p: 90, h: true })}
            mt={size({ p: 5, h: true })} className={styles['intro-container']}>
            <Grid item container flexWrap={'nowrap'} direction={'column'}
                rowGap={size({ p: 1, h: true })}>
                <Grid item>
                    <Typography
                        sx={{
                            fontFamily: 'Archia',
                            fontSize: size({ p: 2.2 }),
                            fontWeight: 600,
                            textAlign: 'center',
                            color: `${COLORS.C2}`,
                            padding: `0px ${size({ p: 10 })}`,
                            mt:'6rem'
                        }}
                        className={styles['intro-title']}
                    >
                        Find the best certified course to grow your skills & define the future
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography
                        sx={{
                            fontFamily: 'Archia',
                            fontSize: size({ p: 1 }),
                            fontWeight: 400,
                            textAlign: 'center',
                            color: `${COLORS.C1}A0`,
                            padding: `0px ${size({ p: 5 })}`
                        }}
                        className={styles['intro-description']}
                    >
                        Elevate your expertise, empower your career. Explore your path to success with our premier certified courses, meticulously designed to enhance your skills and carve a definitive trajectory for your future growth.
                    </Typography>
                </Grid>
            </Grid>
            <Grid item mt={size({ p: 15, h: true, neg: true })} className={styles['intro-lottie']}>
                <Lottie width={size({ p: 45 })} height={size({ p: 45 })}
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: course,
                    }} />
            </Grid>
        </Grid>
    )
}
